import React, { useState } from "react";
import { MdImage } from "react-icons/md";
import CustomButton from "./common/CustomButton/CustomButton";
import CustomDialog from "./common/CustomDialog";

const ShowFileOnUrlWithButton = ({
  url,
  buttonLabel = "Open",
  documentTitle = "Document",
}) => {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  return (
    <div className="p-4 flex flex-col">
      <CustomButton
        startIcon={<MdImage />}
        disabled={!Boolean(url)}
        label={buttonLabel}
        onClick={() => setIsConfirmDialogOpen(true)}
        variant="blur"
        className="flex items-center justify-center gap-2"
      />

      {/* Dialog */}
      <CustomDialog
        open={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        titleClassName="text-center text-base font-bold w-full"
        className="!h-[min(25rem,_90%)] rounded-lg p-4 flex flex-col"
        width={"min(40rem, 90%)"}
      >
        <div className="flex-1 flex flex-col">
          {/* Title */}
          <p className="text-gray-600 text-left border-b pb-4 mb-4">
            {documentTitle}
          </p>

          {/* File preview */}
          <div className="flex-1 flex items-center justify-center overflow-hidden">
            {url ? (
              <img
                src={url}
                alt={documentTitle}
                className="max-h-full max-w-full object-contain rounded"
              />
            ) : (
              <p className="text-gray-400">No document available</p>
            )}
          </div>

          {/* Footer buttons */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              className="py-2 px-4 bg-white border border-gray-300 font-semibold text-base w-[170px] rounded-full"
              onClick={() => setIsConfirmDialogOpen(false)}
            >
              close
            </button>
          </div>
        </div>
      </CustomDialog>
    </div>
  );
};

export default ShowFileOnUrlWithButton;
